import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { WebPage, WebPageTranslation } from '../../../@core/models/WebPage';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WebpagesService } from '../../../@core/services/webpages.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'webpagemanager',
  templateUrl: './webpagemanager.component.html',
  styleUrls: ['./webpagemanager.component.scss']
})
export class WebpagemanagerComponent implements OnInit {

  public webPageID:number = 0;
  constructor(
    public apiProvider: ApiProvider,
    private route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public router: Router,
    public _webpagesService: WebpagesService,

    public datePipe: DatePipe) {
      this.webpage = new WebPage();

      this.route.paramMap.subscribe(params => {
        if(params.get("WebPageID") != null){
          this.webPageID = Number(params.get("WebPageID"));
          this.apiProvider.WebPage(this.webPageID, 0).subscribe(
            (webPage: WebPage) => {
              this.webpage = webPage;
            }, (err: HttpErrorResponse) => {
              this.webpage = null;
            });
          }
        }
      )
      if(this.webPageID == 0){
        this.webpageEn = new WebPageTranslation();
        this.webpageEn.LanguageID = 2;
        this.webpageEn.LanguageText = "EN";
        this.webpageFr = new WebPageTranslation();
        this.webpageFr.LanguageID = 1;
        this.webpageFr.LanguageText = "FR";

        this.webpage.WebPageTranslations.push(this.webpageFr);
        this.webpage.WebPageTranslations.push(this.webpageEn);
      }

    }

  public htmlContent1:string;
  public htmlContent2:string;
  public dateString: string;
  public dayDate: Date;
  public dateF:any=new Date();

  public webpage: WebPage;
  public webpageFr: WebPageTranslation;
  public webpageEn: WebPageTranslation;
  ngOnInit() {
    this._webpagesService.initialiseWebPages(0, 1);
    this.dayDate = new Date();
    this.dateString = this.dayDate.toISOString();
    this.dateF = this.datePipe.transform(this.dayDate, 'yyyy-MM-dd');
  }

  public setParentID(parentID: number) {
    this.webpage.WebPageParentID = parentID;
  }

  public cancelClick(): void {
    this.router.navigate(['Webpages']);
  }

  addEvent(event) {
    console.log("AddEvent");
  }

  public sendClick(): void {
    this.webpage.AvailableDate = this.dayDate;
    if(this.webPageID == 0){
      this.apiProvider.InsertWebPage(this.webpage, this.authenticationService.currentUserValue.UserID).subscribe(
        response => {
          this.router.navigate(['Webpages']);
        });
    }
    else{
      this.apiProvider.UpdateWebPage(this.webpage, this.authenticationService.currentUserValue.UserID).subscribe(
        response => {
          this.router.navigate(['Webpages']);
        });
    }
  }
}
